const FreeAnswer = ({ ...props }) => {

    const answerChoices = props.answerChoices[0]._answer.trim().split('\n') ?? [] // []
    const userAnswer = props.userAnswer.answer_data ? JSON.parse(props.userAnswer.answer_data )[0] : ""
    const pointScored = Number( props.info.quizPointsScored ?? "0" )

    return (
        <div className={`msync-question-container__answer__freeanswer ${pointScored ? 'msync_ld_correct' : 'msync_ld_incorrect'}`}>
            <input type="text" value={ userAnswer } disabled />
            <span>Correct: { answerChoices.join(', ') }</span>
        </div>
    )
}

export default FreeAnswer